define('controllers/modules/calendar/item/activity',[
    // Libs
    'backbone', 'utils',
    // parent
    'controllers/modules/calendar/abstract-item',
    // Models
    'models/calendar/item/text-session',
    // Views | Layout
    'views/modules/calendar/activity/activity-panel'
], function(
    // Libs
    Backbone, U,
    // parent
    AbstractCalendarItemCtrl,
    // Models
    MTextSession,
    // Views | Layout
    VActivityPanel
) {

    var CalendarActivityCtrl = AbstractCalendarItemCtrl.extend({

        lazyInit: function() {
            if (!this.view) {
                this.model = new MTextSession();
                this.view = new VActivityPanel({
                    group: this.group,
                    profile: this.profile,
                    model: this.model,
                    role: this.role,
                    url: Backbone.history.getFragment(),
                });

                this.listenTo(this.view, 'back', this.onBack);
            }

            return this.getLayout();
        },

    });

    return CalendarActivityCtrl;

});

